export default {
  month1: "Janvier",
  month2: "Février",
  month3: "Mars",
  month4: "Avril",
  month5: "Mai",
  month6: "Juin",
  month7: "Juillet",
  month8: "Août",
  month9: "Septembre",
  month10: "Octobre",
  month11: "Novembre",
  month12: "Décembre",

  day1: "Lundi",
  day2: "Mardi",
  day3: "Mercredi",
  day4: "Jeudi",
  day5: "Vendredi",
  day6: "Samedi",
  day7: "Dimanche",

  today: "Aujourd'hui",
  day: "jour",
  week: "semaine",
  month: "mois",
  year: "an",

  filter: "Filtrer",
  filters: "Filtres",
  edit: "Editer",
  create: "Créer",
  new: "Nouveau",
  search: "Indiquez votre recherche",
  "back-to-the-list": "Retour à la liste",
  results: "résultats",
  per_page: "par page",
  "create-new": "Créer nouveau",
  save: "Enregistrer",
  cancel: "Annuler",
  add: "Ajouter",
  delete: "Supprimer",
  actions: "Actions",
  reinitialize: "Réinitialiser",
  import: "Importer",
  export: "Exporter",
  send: "Envoyer",
  print: "Imprimer",
  confirm: "Confirmer",
  confirmation: "Confirmation",
  pending: "En attente",

  "are-you-sure": "Etes-vous sûr de vouloir continuer ?",
  "not-specified": "Non spécifié",
  yes: "Oui",
  no: "Non",

  east: "Est",
  west: "Ouest",
  north: "Nord",
  south: "Sud",

  languages: "Langues",
  french: "Français",
  english: "Anglais",
  spanish: "Espagnol",
  german: "Allemand",
  italian: "Italien",
  dutch: "Néerlandais",
  russian: "Russe",
  swedish: "Suédois",
  norwegian: "Norvégien",

  country: "Pays",
  france: "France",
  belgium: "Belgique",
  england: "Angleterre",
  italy: "Italie",
  spain: "Espagne",
  germany: "Allemagne",
  netherlands: "Pays-Bas",
  russia: "Russie",
  sweden: "Suède",
  norway: "Norvège",

  admin: "Administrateur",
  agent: "Agent",

  name: "Nom",
  last_name: "Nom",
  first_name: "Prénom",
  reference: "Référence",
  company: "Société",
  birthday: "Date de naissance",
  client_number: "N° client",
  status: "Statut",
  email: "Email",
  password: "Password",
  phone: "Tel",
  id_number: "NIE",
  sex: "Sexe",
  man: "Homme",
  woman: "Femme",
  address: "Adresse",
  location: "Localisation",
  street: "Rue",
  number: "Number",
  city: "Ville",
  postcode: "Code postal",
  optional: "Optionnel",
  tasks: "Tâches",
  login: "Se connecter",
  logout: "Se déconnecter",
  source: "Source",

  photos: "photos",
  dashboard: "Tableau de bord",
  calendar: "Calendrier",
  "real-estate": "Immobilier",
  clients: "Clients",
  users: "Utilisateurs",
  editor: "Editeur",
  settings: "Paramètres",
  analytics: "Analyses",
  library: "Bibliothèque",
  note: "Note",
  title:"Titre",
  previous:"Précédant",
  next:"Suivant",
  last_deal:"Dernier deal",

  others: "Autres",

  "page-home": "Accueil",
  "page-about": "A propos",
  "page-services": "Services",
  "page-properties": "Properties",
  "page-sell-house": "Sell your house",
  "page-rent-house": "Rent your house",
  "page-team": "Team",
  "page-contact": "Contact",
  "page-terms": "Conditions",
  "page-privacy": "Privacy",
  "page-clients": "Clients",
  "page-agencies": "Agencies",
  "page-agents": "Agents",
  "page-settings": "Settings",
};
